<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M28 26.666c.738 0 1.335-.597 1.335-1.334v-6.673a2.669 2.669 0 010-5.338V6.65c0-.737-.597-1.335-1.334-1.335H3.978c-.737 0-1.334.598-1.334 1.335v6.672a2.669 2.669 0 010 5.338v6.673c0 .737.597 1.334 1.334 1.334h24.023zM19.334 10A1.333 1.333 0 1122 10v1.334a1.333 1.333 0 01-2.667 0V9.999zm0 5.334a1.333 1.333 0 112.667 0v1.333a1.333 1.333 0 01-2.667 0v-1.333zm0 5.333a1.333 1.333 0 112.667 0V22a1.333 1.333 0 01-2.667 0v-1.333z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'shopTicketFilled'
}
</script>
